import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { styled, SvgIcon } from '@teko/ui';
import { R as Ripple } from './Ripple-16a867a0.js';

const getBackground = (props) => {
    if (props.disabled)
        return props.theme.colors.gray400;
    if (props.outline)
        return props.theme.colors.white;
    switch (props.variant) {
        case 'primary':
            return props.theme.brand.linear || props.theme.brand.primary;
        case 'secondary':
            return props.theme.brand.secondary;
        case 'tertiary':
            return props.theme.brand.tertiary;
        case 'link':
            return 'transparent';
    }
};
const getColor = (props) => {
    if (props.outline) {
        switch (props.variant) {
            case 'primary':
                return props.theme.brand.primary;
            case 'secondary':
                return props.theme.brand.secondary;
            case 'tertiary':
                return props.theme.brand.tertiary;
            default:
                return props.theme.brand.primary;
        }
    }
    switch (props.variant) {
        case 'primary':
            return props.theme.colors.white;
        case 'secondary':
            return props.theme.colors.white;
        case 'tertiary':
            return props.theme.brand.primary;
        case 'link':
            return props.theme.brand.primary;
        default:
            return props.theme.colors.white;
    }
};
const getSize = (props) => {
    switch (props.size) {
        case 'sm':
            return `
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        padding: 0 8px;
      `;
        case 'md':
            return `
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        padding: 0 8px;
      `;
        case 'lg':
            return `
        height: 48px;
        line-height: 48px;
        font-size: 15px;
        padding: 0 8px;
      `;
    }
};
const StyledButton = styled.button((props) => {
    return `
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      opacity: ${props.loading ? 0.69 : 1};
      color: ${getColor(props)};
      background: ${getBackground(props)};
      border: ${props.outline ? `1px solid ${getColor(props)}` : 'none'};
      &:focus {
        outline: none;
      }
      ${props.fullWidth ? `width: 100%;` : ''}
      ${props.disabled ? 'pointer-events: none;' : ''}
      ${getSize(props)}
    `;
}, space);
const Spinner = styled.div(({ theme, outline }) => `
    background: none;
    min-width: 20px;
    margin-right: 8px;
    position: relative;
    @keyframes ldio-yuapljtmof {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .ldio-yuapljtmof  {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      animation: ldio-yuapljtmof 1s linear infinite;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      box-shadow: 0 2px 0 0 ${outline ? theme.brand.loading : theme.colors.white};
      box-sizing: content-box;
    }
`);
let time = 0;
const Button = (_a) => {
    var { children, disabled, fullWidth, loading, variant = 'primary', size = 'md', icon, iconPosition = 'left', rippleColor = 'rgba(255, 255, 255, 0.6)', onClick, outline } = _a, props = __rest(_a, ["children", "disabled", "fullWidth", "loading", "variant", "size", "icon", "iconPosition", "rippleColor", "onClick", "outline"]);
    const handleClick = (event) => {
        event.stopPropagation();
        const rippleDelay = 200;
        const currentTime = new Date().getTime();
        if (onClick)
            setTimeout(() => {
                if (currentTime - time > rippleDelay) {
                    time = currentTime;
                    onClick(event);
                }
            }, rippleDelay);
    };
    return (React.createElement(StyledButton, Object.assign({ onClick: loading ? undefined : handleClick, disabled: disabled, fullWidth: fullWidth, variant: variant, size: size, outline: outline }, props),
        loading ? (React.createElement(Spinner, { outline: outline },
            React.createElement("div", { className: "ldio-yuapljtmof" }))) : (icon && iconPosition === 'left' && React.createElement(SvgIcon, Object.assign({ marginRight: 2 }, icon))),
        children,
        icon && iconPosition === 'right' && React.createElement(SvgIcon, Object.assign({ marginLeft: 2 }, icon)),
        React.createElement(Ripple, { color: rippleColor })));
};

export { Button as B };
